import {
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { useDisclaimers } from '../../../../../../../context/disclaimers-context';
import { huchaLinesColor } from '../../../../../../../helpers/color-tokens';
import { handleScrollToDisclaimer } from '../../../../../../../helpers/disclaimers/disclaimers-utils';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import {
	HuchaDisclaimer2Plus10Text,
	HuchaDisclaimer2Plus15Text,
	HuchaDisclaimer2S10To15Text,
} from '../../disclaimers/hucha-disclaimers';
import { HuchaRenovadoresLabel } from '../../ui/hucha-renovadores-label';
import { StyledBalanceText } from '../../../../shared/ui/styles';

const MainContainerDiv = styled.div`
	display: flex;
	width: 100%;
	padding-top: 20px;

	@media (min-width: 960px) {
		padding-top: 12px;
	}
`;

const StyledC3Wrapper = styled.div`
	flex: 1;

	border: 2px solid ${huchaLinesColor};
	border-radius: 16px;
	position: relative;
	align-content: center;
	padding: var(--size-dynamic0250) var(--size-dynamic0100);

	@media (min-width: 560px) {
		padding: var(--size-dynamic0130) var(--size-dynamic0100);
	}
`;

const StyledC3Content = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	gap: var(--size-dynamic0100);
`;
const Styled1000Wrapper = styled.div`
	display: flex;
	align-items: start;
`;
const StyledAmountText = styled.div`
	display: flex;
	align-items: end;

	& * {
		line-height: 100%;
		font-family: var(--font-family-head);
		font-weight: 100;
	}

	& [data-testid='hucha-amount'] {
		font-size: clamp(60px, 2rem + 2.5vw, 90px);
	}
	& [data-testid='hucha-currency'] {
		font-size: clamp(30px, 1rem + 2vw, 56px);
	}
`;
const StyledTextWrapper = styled.div`
	flex: 1;
	border-top: 2px solid ${huchaLinesColor};
	border-bottom: 2px solid ${huchaLinesColor};
	padding: var(--size-dynamic0050) 4px var(--size-dynamic0050) 4px;
	width: 100%;
	min-width: 210px;
	max-width: 295px;

	@media (max-width: 559px) {
		max-width: 227px;
	}

	@media (min-width: 560px) {
		max-width: 320px;
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;

	/* Mobile */
	@media (max-width: 559px) {
		margin-top: 0px;
	}
`;

const HuchaDisclaimer2TextByTier: Record<string, string> = {
	renovador10To15: HuchaDisclaimer2S10To15Text,
	renovadorPlus10: HuchaDisclaimer2Plus10Text,
	renovadorPlus15: HuchaDisclaimer2Plus15Text,
};

export const HuchaRenovadoresCardC3: React.FC<{
	huchaValues: HuchaVentaValues;
}> = ({ huchaValues }) => {
	const { findBadge } = useDisclaimers();
	const HuchaDisclaimer2Text = HuchaDisclaimer2TextByTier[huchaValues.huchaTier];
	const badge = findBadge(HuchaDisclaimer2Text);

	return (
		<MainContainerDiv data-testid="card-c3-container">
			<StyledC3Wrapper>
				<HuchaRenovadoresLabel />
				<StyledC3Content>
					<Styled1000Wrapper>
						<StyledAmountText>
							<Text data-testid="hucha-amount" color={TokenTextColor.inverted}>
								+1.000
							</Text>
							<Text data-testid="hucha-currency" color={TokenTextColor.inverted}>
								{'€'}
							</Text>
						</StyledAmountText>
						{badge && (
							<StyledReferenceBadge
								variant="large"
								onClick={() => {
									if (badge) handleScrollToDisclaimer(badge);
								}}
							>
								{badge.replace(/\.$/, '')}
							</StyledReferenceBadge>
						)}
					</Styled1000Wrapper>

					<StyledTextWrapper>
						{huchaValues.DGTLabelInfo ? (
							<StyledBalanceText
								appearance={TokenTextAppearance.headline200}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
							>
								para renovar tu coche y que las restricciones de movilidad no te limiten
							</StyledBalanceText>
						) : (
							<StyledBalanceText
								appearance={TokenTextAppearance.headline200}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
							>
								La Excusa Oficial Volkswagen para renovar tu coche este año
							</StyledBalanceText>
						)}
					</StyledTextWrapper>
				</StyledC3Content>
			</StyledC3Wrapper>
		</MainContainerDiv>
	);
};
